export const initialState = {
  isPending: false,
  isMoreFeedbackPending: false,
  isError: false,
  apiData: {},
};
